import { TEN, TWO } from 'base/constants/grid';

export const HORIZONTAL_PADDING = { md: TEN, xs: TWO };
export const DEFAULT_LAYOUT_PADDING = {
  pl: HORIZONTAL_PADDING,
  pr: HORIZONTAL_PADDING,
  pt: 2.5,
  pb: 2.5
};
